import { memo } from 'react'
import BaselineDelete from '~icons/ic/baseline-delete'
import { EntityType } from '@crew/enums/domain'
import { useProjectPermissions } from '@crew/hooks'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import { FileListActionMenu } from 'features/file/components/fileListPage/components/fileListActionMenu/fileListActionMenu'

export type CrewFileActionProps = {
  fileId: string
  fileName: string
  entityType: EntityType
  entityRecordId?: string
  onDelete: () => void
  showDelete?: boolean
}

export const CrewFileAction = memo((props: CrewFileActionProps) => {
  const { hasPrjFileDeletePermission, hasPrjFileDownloadPermission } =
    useProjectPermissions(
      props.entityType,
      props.entityRecordId ?? props.fileId
    )

  return hasPrjFileDeletePermission ? (
    <div className="flex flex-row items-center">
      <FileListActionMenu
        fileId={props.fileId}
        fileName={props.fileName}
        showDownload={hasPrjFileDownloadPermission}
      />

      <CrewButton
        stylingMode="text"
        icon={<BaselineDelete width={20} height={20} />}
        onClick={props.onDelete}
      />
    </div>
  ) : null
})
